<template>
  <div>
    <div class="pass-detail-header">

      <p>Pass Name</p>
      <h2>{{ passDetail.pass_name }}</h2>

      <p>Status: <span>{{ passDetail.status }}</span></p>
      <p>Type of Pass: <span>{{ passDetail.type_of_pass }}</span></p>
      <div v-if="passDetail.status !== 'Deactivated' && passDetail.status !== 'Expired'">
        <p>
          Invite link:
          <router-link v-bind:to="{ name: 'InvitePasses',
            params: { link_id: passDetail.shareable_link_id } }">
            {{ routeUrl }}
          </router-link>
        </p>

        <a href="/scan-pass">Go to Scan A Pass</a>
      </div>
    </div>

    <div class="actions-container">
      <div class="actions-toggle">
        <button type="button" class="btn" @click="onClickToggleAction">
          <i class="fas fa-ellipsis-v"></i>
        </button>
      </div>
      <ul class="actions-list"
        v-show='isToggleActionList'
        v-if="passDetail.status === 'Active' || passDetail.status === 'Pending'">
        <li @click="onClickEdit()">
          <i class="fas fa-edit"></i>
          <span>Edit</span>
        </li>
        <li @click="onClickDelete()">
          <i class="fas fa-trash"></i>
          <span>Delete</span>
        </li>
        <li @click="onClickShare()">
          <i class="fas fa-share-square"></i>
          <span>Share</span>
        </li>
        <li @click="onClickDeactivate()">
          <i class="fas fa-ban"></i>
          <span>Deactivate</span>
        </li>
      </ul>
      <ul class="actions-list" v-show="isToggleActionList" v-else>
        <li @click="onClickDelete()">
          <i class="fas fa-trash"></i>
          <span>Delete</span>
        </li>
      </ul>
    </div>
    <div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    routeUrl: String,
    isToggleActionList: Boolean,
    passDetail: Object,
    onClickDelete: Function,
    onClickDeactivate: Function,
    onClickEdit: Function,
    onClickShare: Function,
    onClickToggleAction: Function
  }
}
</script>

<style>
  .pass-detail-header {
    margin-top: 20px;
  }

  .pass-detail-header p {
    color: #6c757d;
  }

  .actions-toggle button {
    color: #6c757d;
  }
</style>



// WEBPACK FOOTER //
// src/components/passes/PassDetailHeader.vue